module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/6_46baab682086b6271a16575d5e9003b5.png";